import { render, staticRenderFns } from "./WarningTab.vue?vue&type=template&id=4131cbac&scoped=true&"
import script from "./WarningTab.vue?vue&type=script&lang=js&"
export * from "./WarningTab.vue?vue&type=script&lang=js&"
import style0 from "./WarningTab.vue?vue&type=style&index=0&id=4131cbac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4131cbac",
  null
  
)

export default component.exports